import React from "react";
import cx from "classnames";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { Button, ButtonVariant } from "brass-ui-kit";

import { MigrationCountdown } from "components/design-system";
import { useMigrationCountdown } from "../../../hooks/useMigrationCountdown";
import { migrationHeroElementId } from "../../../hooks/useMigrationHeroInView";

import Hero from "../Hero/Hero";

import * as styles from "./MigrationHero.module.scss";

const PAYSTACK_MFB_URL = "https://paystackmfb.com/";
const MIGRATION_HELP_PATH = "/help#account-migration/what-is-happening";

const MigrationHero: React.FC = () => {
  const { isPast } = useMigrationCountdown();

  if (isPast) {
    return <Hero />;
  }

  return (
    <section
      id={migrationHeroElementId}
      className={styles.MigrationHero}
      aria-labelledby="migration-hero-title"
    >
      <div className={styles.MigrationHero_container}>
        <div className={cx("grid-span-1-6", styles.MigrationHero_content)}>
          <header className={styles.MigrationHero_header}>
            <p className={styles.MigrationHero_eyebrow}>What&apos;s next for Brass</p>
            <h1 id="migration-hero-title" className={styles.MigrationHero_title}>
              Brass Banking is moving to Paystack MFB
            </h1>
            <p className={styles.MigrationHero_body}>
              <Link to={MIGRATION_HELP_PATH}>Click here to read more</Link>
            </p>
            <MigrationCountdown variant="hero" />
            <div className={styles.MigrationHero_actions}>
              <Button
                as="a"
                href={PAYSTACK_MFB_URL}
                target="_blank"
                rel="noreferrer"
                variant={ButtonVariant.Primary}
                className={styles.MigrationHero_actions_btn}
              >
                Explore Paystack MFB
              </Button>
            </div>
          </header>
        </div>

        <div className={cx("grid-span-7-6", styles.MigrationHero_image)}>
          <StaticImage
            as="span"
            alt="Brass business banking"
            loading="eager"
            src="../../../assets/media/images/home/hero.png"
          />
        </div>
      </div>
    </section>
  );
};

export default MigrationHero;
